import React from 'react';
import HubinsBO from '../HubinsBO';
import Heading from '@hubins/components/Heading';

const ApprovalsHubinsBackoffice = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Hubins Backoffice</Heading>
      <HubinsBO />
    </>
  );
};

export default ApprovalsHubinsBackoffice;
